import {
  BrandOrderRequirementType,
  RuleGroupConfigType,
} from 'features/Enterprise/Vendor/types/PurchaseTerms'
import { resolveBrandScopeConfigsForProductList } from 'features/Enterprise/Vendor/utils/ruleGroupsMapper'

export const RULE_CONFIGS_MAX_DISTINCT = 100

const toLevelId = (value: number | undefined): number => {
  const id = Number(value)
  if (!Number.isFinite(id) || id <= 0) return 0
  return id
}

export const ruleGroupConfigToSegment = (config: RuleGroupConfigType): string => {
  const brandId = toLevelId(config.brand_id)
  const l1CategoryId = toLevelId(config.l1_category_id)
  const l2CategoryId = toLevelId(config.l2_category_id)
  return `${brandId}:${l1CategoryId}:${l2CategoryId}`
}

export const filterActiveBrandScopeConfigs = (
  configs: RuleGroupConfigType[],
): RuleGroupConfigType[] => configs.filter((config) => config.marked_for_deletion !== true)

export const buildRuleConfigsQueryString = (configs: RuleGroupConfigType[]): string => {
  const seen = new Set<string>()
  const segments: string[] = []

  filterActiveBrandScopeConfigs(configs).forEach((config) => {
    const segment = ruleGroupConfigToSegment(config)
    if (segment === '0:0:0' || seen.has(segment)) return

    seen.add(segment)
    segments.push(segment)
  })

  return segments.slice(0, RULE_CONFIGS_MAX_DISTINCT).join(',')
}

export const buildRuleConfigsQueryStringFromBrandRequirement = (
  requirement: BrandOrderRequirementType,
): string => buildRuleConfigsQueryString(resolveBrandScopeConfigsForProductList(requirement))
